import { render } from "./QuestionPlaceholder.vue?vue&type=template&id=79c8e6ff"
import script from "./QuestionPlaceholder.vue?vue&type=script&lang=js"
export * from "./QuestionPlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__